<template>
    <v-layout>
        <v-container v-if="checkCommentLoaded()">
            <v-card-title class="project">
            <div class="headline" color="">Editing Issues</div>
            </v-card-title>
            <v-card-text class="grey lighten-3">
            <div
                v-for="(comment, index) in this.comments"
                v-bind:key="index"
            >
                <span><b>Question:</b> {{ comment.question }}</span
                ><br />
                <span><b>Comment in question:</b> {{ comment.comment_in_question }}</span
                ><br /><br />
            </div>
            <div><b>Overall Comment:</b> {{ editedItem.final_comment }}</div>
            </v-card-text>
        </v-container>
    </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    // apiUrl: 'project-view',
    apiUrl: "project-type",
    comment_length: 0,
    editedItem: {
      final_comment:''
    },
    comments: {
      comment: "",
      final_comment: "",
    }
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  created() {
    // this.$store.dispatch("setIndexData", [this.apiUrl]);
    // this.editedData();
  },

  methods: {
    checkCommentLoaded(){
      if (this.indexData.pre_comment) {        
        this.comments = this.indexData.pre_comment;
        if(this.indexData.project_data){
            this.editedItem.final_comment = this.indexData.project_data.modify_comment;
        }
        
      // console.log(CommentData);
        return true;
      }else{
        return false;
      }

    },
  },
};
</script>

<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>